const DOCUMENT_FROM = {
    APPLICATION: 'APPLICATION',
    COMPANY: 'COMPANY',
    TC: 'TC',
    RC: 'RC',
    PROCUREMENT: 'PROCUREMENT',
    AUDIT: 'AUDIT',
    FARMER: 'FARMER',
  };

export default DOCUMENT_FROM;

export const INVENTORY_TYPE = {
  CERTIFIED: "CERTIFIED",
  NON_CERTIFIED: "NON_CERTIFIED",
  EXTERNAL_CERTIFIED: "EXTERNAL_CERTIFIED",
};